<template>
  <section class="block">
    <div class="container mx-auto px-4 py-10">
      <div class="grid max-w-screen-xl grid-cols-1 gap-8 mx-auto text-gray-900 bg-white md:grid-cols-2 md:px-12 lg:px-16 xl:px-32">
        <loading :status="loading"> </loading>
        <div class="flex flex-col justify-between">
          <div>
            <h2 class="text-4xl font-bold leading-tight lg:text-5xl">
              {{ $t('Contact Us') }}
            </h2>
            <p class="mt-1 text-xl text-gray-700 text-semibold"> {{ $t('We do love to hear from you') }}. </p>
          </div>
          <div class="mt-8 text-center">
            <svg-vue icon="undraw.contact"> </svg-vue>
          </div>
        </div>
        <div>
          <template v-if="message">
            <button @click="reset" class="btn text-center">
              {{ $t('Back') }}
            </button>
            <div class="flex p-5 text-center text-xl">
              <p class="px-2">
                {{ message }}
              </p>
            </div>
          </template>
          <template v-else>
            <form @submit.prevent="submitRequest">
              <div>
                <span class="text-sm font-bold text-gray-600 uppercase">
                  {{ $t('Full Name') }}
                </span>
                <input
                  :placeholder="$t('Full Name')"
                  class="w-full p-3 mt-2 text-gray-900 bg-gray-300 rounded-lg focus:outline-none focus:shadow-outline"
                  required=""
                  type="text"
                  v-model="contact.name"
                />
              </div>
              <div class="mt-8">
                <span class="text-sm font-bold text-gray-600 uppercase">
                  {{ $t('Email') }}
                </span>
                <input
                  :placeholder="$t('Email')"
                  class="w-full p-3 mt-2 text-gray-900 bg-gray-300 rounded-lg focus:outline-none focus:shadow-outline"
                  required=""
                  type="email"
                  v-model="contact.email"
                />
              </div>
              <div class="mt-8">
                <span class="text-sm font-bold text-gray-600 uppercase">
                  {{ $t('Message') }}
                </span>
                <textarea :placeholder="$t('Message')" class="w-full h-32 p-3 mt-2 text-gray-900 bg-gray-300 rounded-lg focus:outline-none focus:shadow-outline" required="" v-model="contact.message">
                </textarea>
              </div>
              <div class="mt-8">
                <button class="w-full p-3 text-sm font-bold tracking-wide text-gray-100 uppercase bg-indigo-700 rounded-lg focus:outline-none focus:shadow-outline" type="submit">
                  {{ $t('Send Message') }}
                </button>
              </div>
            </form>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'contact-us',
  data() {
    return {
      loading: false,
      message: null,
      contact: {
        name: null,
        email: null,
        message: null,
      },
    };
  },
  methods: {
    submitRequest() {
      this.loading = true;
      if (this.$store.state.settings.recaptcha_enabled) {
        this.$recaptcha('login').then((token) => {
          this.contact.captcha_hash = token;
          this.send();
        });
      } else {
        this.send();
      }
    },
    send() {
      axios
        .post(route('contact.us'), this.contact)
        .then((response) => {
          this.message = response.data.message;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    reset() {
      this.message = null;
      this.contact.name = null;
      this.contact.email = null;
      this.contact.message = null;
    },
  },
};
</script>
